import { useMutation } from '@tanstack/react-query';
import { API_PAYMENTS_URL } from '@/constants/config';

interface Params {
  numberOfSplits: number;
  numberOfCoveredSplits: number;
  totalAmount: number;
  remainingAmount: number;
}

export const calculateSplitMutation = () => {
  return useMutation({
    mutationFn: (params: Params) =>
      fetch(`${API_PAYMENTS_URL}/split-payments/calculations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'SPLIT_EQUALLY',
          ...params,
        }),
      }).then(res => res.json()),
  });
};
